var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.94214C1 10.8438 4.41328 14.0704 5.92408 15.3074C6.1403 15.4844 6.24971 15.574 6.41102 15.6194C6.53663 15.6548 6.7215 15.6548 6.84711 15.6194C7.00873 15.5739 7.11737 15.4852 7.3344 15.3075C8.8452 14.0705 12.2583 10.8442 12.2583 6.9425C12.2583 5.46595 11.6653 4.04971 10.6096 3.00563C9.55391 1.96156 8.1222 1.375 6.62925 1.375C5.1363 1.375 3.70443 1.96164 2.64875 3.00572C1.59307 4.0498 1 5.4656 1 6.94214Z",
    stroke: "#FB8500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02084 6.20001C5.02084 7.08827 5.74092 7.80835 6.62918 7.80835C7.51744 7.80835 8.23752 7.08827 8.23752 6.20001C8.23752 5.31175 7.51744 4.59168 6.62918 4.59168C5.74092 4.59168 5.02084 5.31175 5.02084 6.20001Z",
    stroke: "#FB8500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e1745d6090506c8e1726eaa7ff3a85b6.svg";
export { ForwardRef as ReactComponent };